import axios, { AxiosResponse } from 'axios';
import { getCookie } from '@/utils/cookies';
import { IM_COMMON_CONFIG } from '@/configs/constants';
import { getSidToken } from '@/utils/helpers';
import { debugConsole } from '@aio/utils';
import { ApiConfigs } from '../schemas/service';
import { sendSentryError, sendSentryMessage } from './request';

const api: ApiConfigs = {
  voiceToText: {
    url: '/rest/zt/imc_message_service/app/voice_to_text',
    method: 'POST'
  }
};

const common = {
  async voiceToText(audio: string) {
    try {
      const token = await getSidToken();
      const headers = {
        kpn: IM_COMMON_CONFIG.kpn,
        [`${IM_COMMON_CONFIG.sid}_st`]: token,
        userId: getCookie('ud'), // 用户ID
        subBiz: IM_COMMON_CONFIG.subBizGroup,
        did: getCookie('did') // 设备ID
      };
      debugConsole('headers', headers);
      // eslint-disable-next-line camelcase
      type TResponse = { result: number; error_msg: string; data: string };
      const response: AxiosResponse<TResponse> = await axios.post(
        api.voiceToText.url as string,
        audio,
        {
          timeout: 30 * 1000,
          headers: {
            'Content-Type': 'application/json',
            ...headers
          }
        }
      );
      if (response.data.result === 1) {
        return Promise.resolve(response.data.data);
      }
      sendSentryMessage(response);
      return Promise.reject(new Error(response.data.error_msg));
    } catch (error) {
      sendSentryError(error, 'voiceToTextError');
      return Promise.reject(error);
    }
  }
};

export default common;
